import { render, staticRenderFns } from "./chengxingMb.vue?vue&type=template&id=af8a1576&scoped=true&"
import script from "./chengxingMb.vue?vue&type=script&lang=js&"
export * from "./chengxingMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8a1576",
  null
  
)

export default component.exports